import {
    type RouteConfigCrew,
    type Route,
    type RouteConfigType,
    type PathGenerationArgs,
    type RouteConfigPath,
    extractParams,
    generateHash,
    generatePath,
    generateReactRouterPath,
    RouteConfig,
    withPath,
} from '@famly/vet_navigation_route-config';

export {
    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    type RouteConfigCrew,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    type Route,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    type RouteConfigType,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    type PathGenerationArgs,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    type RouteConfigPath,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    extractParams,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    generateHash,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    generatePath,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    generateReactRouterPath,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    RouteConfig,

    /**
     * @deprecated import from '@famly/vet_navigation_route-config'
     */
    withPath,
};

// Used to attribute Sentry errors in routes to a specific crew
/**
 * @deprecated import RouteConfigCrew from '@famly/vet_navigation_route-config'
 */
export type Crew = RouteConfigCrew;

export default RouteConfig;
